import GptAd, { GptAdProps } from "./GptAd";
import styles from "./Cineflex.module.scss";
import cx from "classnames";

const CineflexAd = ({ ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, "ad-hidden js-cineflex-ad")}
      format="cineflex"
      sizesAt0="cineflex"
      targetingPos="cineflex"
      lazyLoadScreens={0}
      {...props}
    />
  );
};

export default CineflexAd;
